module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 pr-1 pl-2"
  }, [_c('div', {
    staticClass: "mt-2 card"
  }, [_c('h3', {
    staticClass: "font-grey kne-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard.new_note_title')))]), _vm._v(" "), _c('regular-textarea', {
    staticClass: "p-2",
    attrs: {
      "value": _vm.note.text,
      "placeholder": _vm.$t('Dashboard.new_note_message'),
      "rows": "4"
    },
    on: {
      "input": function($event) {
        _vm.note.text = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container pb-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 pl-2 pr-1",
    attrs: {
      "value": _vm.note.name,
      "placeholder": _vm.$t('Dashboard.new_note_name')
    },
    on: {
      "input": function($event) {
        _vm.note.name = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 pr-2 pl-1"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.noteFilled
    },
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('General.send')) + "\n              ")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 card"
  }, [_c('h3', {
    staticClass: "kne-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard.statistic_title')))]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('bar-chart', {
    attrs: {
      "chart-data": {
        labels: [_vm.$t('OrderCurrent.stats.processing'), _vm.$t('OrderCurrent.stats.dispatch'), _vm.$t('OrderCurrent.stats.pick'), _vm.$t('OrderCurrent.stats.transit'), _vm.$t('OrderCurrent.stats.delivered'), _vm.$t('OrderCurrent.stats.transferred'), _vm.$t('OrderCurrent.stats.rejected')],
        datasets: [{
          label: _vm.$t('OrderCurrent.title'),
          backgroundColor: ['#f7941e', '#ff5151', '#515eff', '#43de8f', '#de438b', '#43d7de', '#decb43', '#d46a6a'],
          data: [_vm.count.processing, _vm.count.dispatch, _vm.count.pick, _vm.count.transit, _vm.count.drop, _vm.count.transfer, _vm.count.reject]
        }]
      },
      "options": {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 pl-1 pr-2"
  }, [_c('div', {
    staticClass: "mt-2 card"
  }, [_c('h3', {
    staticClass: "font-grey kne-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard.notes_title')))]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "reversedNotes",
      "hide-single-page": true,
      "limit": 5
    }
  }), _vm._v(" "), _c('paginate', {
    attrs: {
      "name": "reversedNotes",
      "tag": "div",
      "list": _vm.reversedNotes,
      "per": 12
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, _vm._l((_vm.paginated('reversedNotes')), function(note) {
    return _c('div', {
      key: note['.key'],
      staticClass: "card-block p-3 message",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        "href": '#collapse' + note['.key'],
        "aria-expanded": "true",
        "aria-controls": '#collapse' + note['.key']
      }
    }, [_c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'collapse' + note['.key'],
        "role": "tabpanel",
        "aria-labelledby": "headingOne"
      }
    }, [_c('p', {
      staticClass: "text-justify"
    }, [_vm._v(_vm._s(note.text))])]), _vm._v(" "), _c('p', {
      staticClass: "header font-grey"
    }, [_c('i', [_vm._v(_vm._s(note.name))]), _vm._v(" "), _c('i', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm.getDate(note.date)))])])])
  }))], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48dc9fe9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Dashboard.vue
// module id = 838
// module chunks = 1